const cssPaymentStateReducer = (state = '', action) => {
	switch(action.type){
	case 'CSSPAYMENTSTATEVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default cssPaymentStateReducer;